import { FC, useState } from "react";
import { useNavigate } from "react-router-dom";
import { postArticleGroupDiscount } from "../../app/services/articleGroupDiscountService";
import { useAppDispatch } from "../../app/hooks";
import { useAccount, useMsal } from "@azure/msal-react";

import Form from "react-bootstrap/Form";
import { Alert, Breadcrumb, Button, Col, Row } from "react-bootstrap";
import {
  ArticleGroupDiscount,
  defaultArticleGroupDiscount,
} from "../../models/responses/articleGroupDiscount";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";

interface Props {}

const ArticleGroupDiscountAdd: FC<Props> = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const [displayError, setDisplayError] = useState(false);
  const isWaitingArticleGroupDiscountPostResponse = useSelector(
    (state: RootState) =>
      state.articleGroupDiscount.isWaitingArticleGroupDiscountPostResponse,
  );

  const [articleGroupDiscountData, setArticleGroupDiscountData] =
    useState<ArticleGroupDiscount>(defaultArticleGroupDiscount);

  const handleAddArticleGroupDiscount = () => {
    setDisplayError(false);
    dispatch(
      postArticleGroupDiscount(
        instance,
        account,
        articleGroupDiscountData,
        onSuccess,
      ),
    );
  };

  const onSuccess = (articleGroupDiscountId: string | null) => {
    if (articleGroupDiscountId === null) {
      setDisplayError(true);
      return;
    }

    setTimeout(() => {
      navigate(`../${articleGroupDiscountId}`, { relative: "path" });
    }, 500);
  };

  return (
    <div>
      <Breadcrumb>
        <Breadcrumb.Item href="/article-group-discounts">
          Artikelgruppsrabatter
        </Breadcrumb.Item>
        <Breadcrumb.Item active>Ny artikelgruppsrabatt</Breadcrumb.Item>
      </Breadcrumb>
      <hr />
      <Form className="w-3">
        <Row>
          <Col xs={12} md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Namn *</Form.Label>
              <Form.Control
                type="text"
                value={articleGroupDiscountData.name}
                onInput={(e) =>
                  setArticleGroupDiscountData({
                    ...articleGroupDiscountData,
                    name: e.currentTarget.value,
                  })
                }
              />
            </Form.Group>
          </Col>

          <Col xs={12} md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Beskrivning *</Form.Label>
              <Form.Control
                type="text"
                value={articleGroupDiscountData.description}
                onInput={(e) =>
                  setArticleGroupDiscountData({
                    ...articleGroupDiscountData,
                    description: e.currentTarget.value,
                  })
                }
              />
            </Form.Group>
          </Col>
          <Row>
            <Col xs={12} md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Rabatt %</Form.Label>
                <Form.Control
                  type="number"
                  value={articleGroupDiscountData.discountPercentage}
                  onInput={(e) =>
                    setArticleGroupDiscountData({
                      ...articleGroupDiscountData,
                      discountPercentage: Number(e.currentTarget.value),
                    })
                  }
                />
              </Form.Group>
            </Col>
            <Col xs={12} md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Artikelgrupp (unikt ID)</Form.Label>
                <Form.Control
                  type="text"
                  value={articleGroupDiscountData.externalGroupId}
                  onInput={(e) =>
                    setArticleGroupDiscountData({
                      ...articleGroupDiscountData,
                      externalGroupId: e.currentTarget.value,
                    })
                  }
                />
              </Form.Group>
            </Col>
          </Row>
        </Row>

        <div className="text-end">
          <Button
            variant="primary"
            className="mb-3"
            onClick={handleAddArticleGroupDiscount}
            disabled={
              !(
                articleGroupDiscountData.name !== undefined &&
                articleGroupDiscountData.name.length > 0 &&
                articleGroupDiscountData.description !== undefined &&
                articleGroupDiscountData.description.length > 0 &&
                articleGroupDiscountData.discountPercentage !== undefined &&
                articleGroupDiscountData.discountPercentage >= 0 &&
                !isWaitingArticleGroupDiscountPostResponse
              )
            }
          >
            Lägg till artikelgruppsrabatt
          </Button>
        </div>

        <Alert key="alert" variant="danger" show={displayError}>
          <p>Något gick fel, kontrollera uppgifterna och försök igen.</p>
        </Alert>
      </Form>
    </div>
  );
};

export default ArticleGroupDiscountAdd;
